<template>
    <div
        class="popper"
        :class="{'bottom': placement === 'bottom'}"
    >
        <div
            v-if="image && type=='image'"
            class="popper-inner image-upload"
        >
            <ul class="editor-style">
                <li 
                    title="Загрузить изображение"
                    @click="image.chooseFile()"
                >
                    <i class="fa fa-lg fa-cloud-upload" />
                </li>
                <li
                    v-if="$root.siteId"
                    title="Выбрать из загруженных"
                    @click="openBrowser"
                >
                    <i class="fa fa-lg fa-list-alt" />
                </li>
            </ul>
            <div class="sep" />
            <ul class="editor-style">
                <li
                    v-if="image.hasImage()" 
                    title="Добавить ссылку"
                    @click.prevent="showUrlPrompt" 
                >
                    <i class="fa fa-lg fa-link" />
                </li>
                <li
                    v-else
                    class="disabled"
                    title="Загрузите изображение!"
                >
                    <i class="fa fa-lg fa-link" />
                </li>
                <li
                    v-if="image.hasImage()"
                    title="Добавить атрибут alt="
                    @click.prevent="showAltPrompt"
                >
                    <i class="fa fa-lg fa-comment-o" />
                </li>
                <li
                    v-else
                    class="disabled"
                    title="Загрузите изображение!"
                >
                    <i class="fa fa-lg fa-comment-o" />
                </li>
            </ul>
            <div
                v-if="image.hasImage()"
                class="sep"
            />
            <ul class="editor-style">
                    <li
                        title="Поместить изображение полностью"
                        @click="fitHeight"
                    >
                        <i class="fa fa-lg fa-square-o" />
                    </li>
            </ul>
            <div class="editor-style">
                <div class="input-group-append">
                    <input
                        v-model.number="h"
                        title="Высота блока с изображением"
                        class="height-input form-control"
                        type="number"
                        min="5"
                        max="1000"
                    >
                </div>
            </div>
        </div>
        <div
            v-if="type=='button'"
            class="popper-inner"
        >
            <div class="editor-style">
                <li @click.prevent="showUrlPrompt">
                    <i class="fa fa-lg fa-link" />
                </li>
            </div>
        </div>
        <filebrowser
            :active="browser"
            @close="browser=false"
            @imagechosen="changeImage"
        />
    </div>
</template>

<script>
    import Vue from 'vue'
    import FileBrowser from './FileBrowser.vue'


    export default {
        name: 'BlockParams',
        props: {
            'container': {
                validator: function (value) {
                    return true
                },
                default: null,
            },
            'data': {
                type: Object,
                default: null,
            },
            'ih': {
                type: Number,
                default: null,
            },
            'placement': {
                type: String,
                default: 'top',
            },
            'image': {
                type: Object,
                default: null,
            },
            'type': {
                type: String,
                default: 'image'
            },
        },
        data: function(){
            return {
                h: this.data.height || 200,
                bgColor: {
                    hex: this.data.bgColor || this.$root.palette[0] 
                },
                alt: '',
                pickerActive: false,
                browser: false,
            }
        },
        watch: { 
            ih: function(newVal, oldVal) {
                this.h = this.ih;
            },
            h: function(newVal, oldVal) {
                this.$emit('height-changed', this.h); 
            },
        },
        methods: {
            showUrlPrompt: function (){
                this.$parent.isForced = true;
                this.$dialog.confirm('', {
                    view: 'urlprompt',
                    href: this.data.href,
                    utm_medium: this.$root.utm_medium,
                    utm_source: this.$root.utm_source,
                    utm_campaign: this.$root.utm_campaign,
                    utm_content: this.data.id,
                    backdropClose: false,
                }).then((dialog) => {
                    dialog.close && dialog.close()
                    this.$parent.isForced = false;
                    if (dialog.data) {
                        this.$emit('update', this.data.id, {
                            'href': dialog.data 
                        });
                    } else if (dialog.data == null){
                        return;
                    } else {
                        this.$parent.href = null;
                    }
                }).catch(function(e) {
                    console.log(e);
                });
            },
            showAltPrompt: function (){
                this.$parent.isForced = true;
                this.$dialog.confirm('', {
                    view: 'altprompt',
                    alt: this.data.alt,
                    backdropClose: false,
                }).then((dialog) => {
                    dialog.close && dialog.close()
                    this.$parent.isForced = false;
                    if (dialog.data) {
                        this.$emit('update', this.data.id, {
                            'alt': dialog.data 
                        });
                    } else if (dialog.data == null){
                        return;
                    } else {
                        this.$parent.href = null;
                    }
                }).catch(function(e) {
                    console.log(e);
                });
            },
            updatebgColor: function(color) {
                this.bgColor = color.hex;

                this.$emit('update', this.data.id, {
                    'bgColor': color.hex 
                });

                this.pickerActive = false;
                this.$parent.isEdited = false;
            },
            fitHeight: function() {
                this.$emit('height-auto'); 
            },
            openBrowser: function() {
                this.browser = true;
            },
            changeImage: function(id, url) {
                this.browser = false;
                this.$emit('imagechosen', id, url);
            }
        }
    }
</script>
